















import { defineComponent } from '@vue/composition-api';
import { ButtonType } from '@getaccept/lib-ui';
import PoweredByLogo from '../../../assets/powered-by-ga.svg';

export default defineComponent({
  components: {
    PoweredByLogo,
  },
  setup() {
    return { ButtonType };
  },
});
